import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles(theme => ({
  grid: {
    marginTop: '75px',
    marginBottom: '75px',
  },
}));
